import React from "react";
import Breadcrumbs from "../../../CommanCom/breadcrumbs";
import Table from "./Table";

const OnboardingList = () => {
    return (
        <>
            <Breadcrumbs
                btn_name={'Add Candidate'}
                Page_heading={'Onboarding Process'}
                privious_slug={'Dashboard'}
            />
            <Table />
        </>
    )
}
export default OnboardingList;